import { render, staticRenderFns } from "./DepositReturnRegistrationPopup.vue?vue&type=template&id=0df9fe42&"
import script from "./DepositReturnRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./DepositReturnRegistrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports